import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional } from "valibot";

export const Route = createFileRoute("/new-supplier")({
  validateSearch: object({ pageIdx: fallback(optional(number(), 0), 0) }),
  component: lazyRouteComponent(() => import("./+NewSupplier")),
  head: () => ({
    meta: [...seo({ title: "Become a Supplier" }), { name: "robots", content: "noindex" }],
  }),
});
